import revive_payload_client_vKYgRlTS3H from "/app/node_modules/.pnpm/nuxt@3.7.0_@parcel+watcher@2.3.0_@types+node@20.4.7_encoding@0.1.13_eslint@8.49.0_optionator@_rawm7zxdkkcslgg7hpa2pibc6y/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import router_FyYUWBTIyJ from "/app/node_modules/.pnpm/nuxt@3.7.0_@parcel+watcher@2.3.0_@types+node@20.4.7_encoding@0.1.13_eslint@8.49.0_optionator@_rawm7zxdkkcslgg7hpa2pibc6y/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import plugin_vue3_Nqp5Ra2iD6 from "/app/node_modules/.pnpm/@pinia+nuxt@0.4.11_@vue+composition-api@1.7.2_vue@3.4.37_typescript@5.2.2___rollup@3.28.1_typ_hwak7a3a5whbfxlrntrnveecoa/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import unhead_nmEshZmYas from "/app/node_modules/.pnpm/nuxt@3.7.0_@parcel+watcher@2.3.0_@types+node@20.4.7_encoding@0.1.13_eslint@8.49.0_optionator@_rawm7zxdkkcslgg7hpa2pibc6y/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import prefetch_client_SNMHtynNHK from "/app/node_modules/.pnpm/nuxt@3.7.0_@parcel+watcher@2.3.0_@types+node@20.4.7_encoding@0.1.13_eslint@8.49.0_optionator@_rawm7zxdkkcslgg7hpa2pibc6y/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_wy0B721ODc from "/app/node_modules/.pnpm/@nuxtjs+device@3.2.4/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import plugin_M980Vu9Uc0 from "/app/node_modules/.pnpm/dayjs-nuxt@1.1.2_rollup@3.28.1/node_modules/dayjs-nuxt/dist/runtime/plugin.mjs";
import unocss_MzCDxu9LMj from "/app/.nuxt/unocss.mjs";
import vant_lazyload_plugin_W13KNvxip6 from "/app/.nuxt/vant-lazyload.plugin.mjs";
import chunk_reload_client_y2sC7gb94j from "/app/node_modules/.pnpm/nuxt@3.7.0_@parcel+watcher@2.3.0_@types+node@20.4.7_encoding@0.1.13_eslint@8.49.0_optionator@_rawm7zxdkkcslgg7hpa2pibc6y/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import api_GFfDXud5Cr from "/app/plugins/api.ts";
import arms_client_t6SmJsMONi from "/app/plugins/arms.client.ts";
import eruda_client_vJ8k1nOnXi from "/app/plugins/eruda.client.ts";
import pinia_48xmdi2HHl from "/app/plugins/pinia.ts";
import vue_query_wrmMkNpEpe from "/app/plugins/vue-query.ts";
export default [
  revive_payload_client_vKYgRlTS3H,
  router_FyYUWBTIyJ,
  plugin_vue3_Nqp5Ra2iD6,
  components_plugin_KR1HBZs4kY,
  unhead_nmEshZmYas,
  prefetch_client_SNMHtynNHK,
  plugin_wy0B721ODc,
  plugin_M980Vu9Uc0,
  unocss_MzCDxu9LMj,
  vant_lazyload_plugin_W13KNvxip6,
  chunk_reload_client_y2sC7gb94j,
  api_GFfDXud5Cr,
  arms_client_t6SmJsMONi,
  eruda_client_vJ8k1nOnXi,
  pinia_48xmdi2HHl,
  vue_query_wrmMkNpEpe
]